function clone(input) {
	return JSON.parse(JSON.stringify(input));
}

const production = {
	isProd: true,
	cdnHost: 'https://cdn.gfzq.cn',
	cdnRoot: 'https://cdn.gfzq.cn/gfbroker',
	serverHost: 'https://broker.gf.com.cn',
	saServerUrl: 'https://behavior.gf.com.cn:443/sa?project=gfbroker',
	saWebUrl: 'http://10.2.79.161:8108/?project=gfbroker',
	ishareServer: 'http://ishare.gf.com.cn',
  robotServer: 'https://robot.gf.com.cn',
  personServer: 'http://person.sac.net.cn'
}

const testing = {
	isProd: false,
	cdnHost: 'https://cdn.gfzq.cn',
	cdnRoot: 'https://cdn.gfzq.cn/gfbroker/dev/gfbroker',
	serverHost: 'https://broker-test.gf.com.cn',
	saServerUrl: 'https://behavior.gf.com.cn:443/sa?project=test',
	saWebUrl: 'http://10.2.79.161:8108/?project=test',
	ishareServer: 'http://isharedev03.gf.com.cn',
  robotServer: 'https://robotuat.gf.com.cn',
  personServer: 'http://124.127.51.156'
}

// for bypassing the cross origin check, please see devServer.proxy part at webpack.config.js
const local = clone(testing)
local.serverHost = ''

let getConfig = function () {
	if (window.location.hostname.indexOf('broker.gf.com.cn') >= 0) {
		return production
	} else if (window.location.pathname.indexOf('/gfbroker/share') === 0 ||
		window.location.pathname.indexOf('/gfbroker/release') === 0 ||
		window.location.pathname.indexOf('/gfbroker/site') === 0) {
		return production
	} else if (window.location.pathname.indexOf('/gfbroker/dev/') === 0 || window.location.hostname === 'localhost') {
		return testing
	} else if (window.location.hostname === '127.0.0.1' || window.location.hostname === 'localhost' || window.location.hostname === 'my.gf.com.cn') {
		testing.serverHost = '';
		return testing
	} else {
		return testing
	}
}

export {getConfig}




// WEBPACK FOOTER //
// ./src/common/js/server-config.js